import { render, staticRenderFns } from "./AIReports.vue?vue&type=template&id=117bc829&scoped=true"
import script from "./AIReports.vue?vue&type=script&lang=js"
export * from "./AIReports.vue?vue&type=script&lang=js"
import style0 from "./AIReports.vue?vue&type=style&index=0&id=117bc829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117bc829",
  null
  
)

export default component.exports